window.SidebarFormValidator = {

	pf: function() {
		if ($('#divSeletorEstado').is(':visible')) {
			$('#formCadastroPF').validate();
			$('#inputNovoEstado').rules('remove','required');
			$('#estado').rules('add','required');
			$('#formCadastroPF').validate();
		} else {
			$('#formCadastroPF').validate();
			$('#inputNovoEstado').rules('add','required');
			$('#estado').rules('remove','required');
			$('#formCadastroPF').validate();
		}
		
		if ($('#divSeletorCidade').is(':visible')) {
			$('#formCadastroPF').validate();
			$('#inputNovaCidade').rules('remove','required');
			$('#cidade').rules('add','required');
			$('#formCadastroPF').validate();
		} else {
			$('#formCadastroPF').validate();
			$('#inputNovaCidade').rules('add','required');
			$('#cidade').rules('remove','required');
			$('#formCadastroPF').validate();
		}

		if ($('#inputEmail').val()!='') {
			if ($('#emailExiste').val()!='') {
				$('#formCadastroPF').validate()
			} else {
				$('#formCadastroPF').validate();
			}
		}

		if ($('#formCadastroPF').valid()) {
			return true;
		} else {
            $('html, body').animate({
                scrollTop: $(".error:visible").eq(0).parent().offset().top - 80
            }, 1000);
            return false;
		}
	}, //end of function pf()

	pj: function() {
		if ($('#divSeletorEstado').is(':visible')) {
			$('#formCadastroPJ').validate();
			$('#inputNovoEstado').rules('remove','required');
			$('#estado').rules('add','required');
			$('#formCadastroPJ').validate();
		}
		else {
			$('#formCadastroPJ').validate();
			$('#inputNovoEstado').rules('add','required');
			$('#estado').rules('remove','required');
			$('#formCadastroPJ').validate();
		}
		if ($('#divSeletorCidade').is(':visible')) {
			$('#formCadastroPJ').validate();
			$('#inputNovaCidade').rules('remove','required');
			$('#cidade').rules('add','required');
			$('#formCadastroPJ').validate();
		}
		else {
			$('#formCadastroPJ').validate();
			$('#inputNovaCidade').rules('add','required');
			$('#cidade').rules('remove','required');
			$('#formCadastroPJ').validate();
		}
		if ($('#inputEmail').val()!='') {
			if ($('#emailExiste').val()!='') {
				$('#formCadastroPJ').validate();
			}
			else {
				$('#formCadastroPJ').validate();
			}
		}
		if ($('#formCadastroPJ').valid()) {
			return true;
		} else {
            $('html, body').animate({
                scrollTop: $(".error:visible").eq(0).parent().offset().top - 80
            }, 1000);
            return false;
		}
	}, //end of function pj()

	//TODO: separar a validacao do register itself
	userUpdate: function() {
		$('#divWarning').hide();
		var validou_formatos = true; // ????
		$('#formAtualizaCadastroUsuario').removeData('validator');

		if ($('#inputPais').val()==5) {
				$('#formAtualizaCadastroUsuario').validate({
				rules: {
					estado: {required: true},
					cidade: {required: true},
					endereco_bairro: {required: true},
					cpf: {cpf: true, required: true},
                    telefone_residencial: {telefone_brasileiro: true, required: true},
					// inputDataNascimento: {dateBR: true, required: true},
					cep: {cep: true, required: true},
					cnpj:{
						required: $("#inputCNPJ").length > 0,
					}
				},
				messages: {
					cnpj: {
						cnpj: 'CNPJ inválido'
					}
				},
				invalidHandler: function(form, validator) {
					if (!validator.numberOfInvalids())
						return;

					$('html, body').animate({
						scrollTop: $(validator.errorList[0].element).offset().top - 100
					}, 2000);

				},

			});
		} else {
			// valores fakes para não serem validados (bad solution!)
			$('#formAtualizaCadastroUsuario').validate({
			 	rules: {
			 		novo_estado: {required: true},
			 		nova_cidade: {required: true},
			 		endereco_bairro: {required: false},
			 		cpf: {required: false},
			 		cep: {cep: true, required: false},
			 		cnpj:{
			 			required: false,
			 		}
			 	},
			 	messages: {
			 		cnpj: {
			 			cnpj: 'CNPJ inválido'
			 		}
			 	},
			 	ignore: '.ignore',
			 	invalidHandler: function(form, validator) {
			 		if (!validator.numberOfInvalids()) {
			 			return;
			 		};
			 		console.log($(validator.errorList[0].element));
			 		$('html, body').animate({
			 			scrollTop: $(validator.errorList[0].element).offset().top-25
			 		}, 2000);
			 	},
			});
		}
		//Passou a validação??
		if ( (validou_formatos) && ($('#formAtualizaCadastroUsuario').valid()) && ($('#emailExiste').val()!='em uso') ) {
            // Tratamento
            var sName = $('#inputNomeCompleto').val();
            if (typeof sName !== typeof undefined) {
            	sName.replace("'","\\'");
            }
            var sEmail = $('#inputEmail').val();
            if (typeof sEmail !== typeof undefined) {
            	sEmail.replace("'","");
            }
            var sCompanyName = $('#inputCompanyName').val();
            if (typeof sCompanyName !== typeof undefined) {
            	sCompanyName.replace("'","\\'");
            }
            var sNewCity = $('#inputNovaCidade').val();
            if (typeof sNewCity !== typeof undefined) {
            	sNewCity.replace("'","\\'");
            }
            var sNewState = $('#inputNovoEstado').val();
            if (typeof sNewState !== typeof undefined) {
            	sNewState.replace("'","\\'");
            }
            var sAddress = $('#inputEnderecoRua').val();
            if (typeof sAddress !== typeof undefined) {
            	sAddress.replace("'","\\'");
            }
            var sNumber = $('#inputEnderecoNumero').val();
            if (typeof sNumber !== typeof undefined) {
            	sNumber.replace("'","\\'");
            }
            var sComplement = $('#inputEnderecoComplemento').val();
            if (typeof sComplement !== typeof undefined) {
            	sComplement.replace("'","\\'");
            }
            var sNeighborhood = $('#inputEnderecoBairro').val();
            if (typeof sNeighborhood !== typeof undefined) {
            	sNeighborhood.replace("'","\\'");
            }
            var sLiteralState = $('#inputNovoEstado').val();
            if (typeof sLiteralState !== typeof undefined) {
            	sLiteralState.replace("'","\\'");
            }
            var sLiteralCity = $('#inputNovaCidade').val();
            if (typeof sLiteralCity !== typeof undefined) {
            	sLiteralCity.replace("'","\\'");
            }

            $('.js-evbind-updateUserSidebar').prop('disabled',true);
            $('.js-evbind-updateUserSidebar').prop('value','Aguarde...');    
            $('#divLoadingContent').show(); 

            $.ajax({
            	type: 'POST',
            	url: App.webRoot + 'projeto/ajaxAtualizaEndereco',
            	data: { projectId: ProjectPage.project_id,
            	user_id: $("#uid").val(),
            	type: $("#utype").val(),
            	name: sName,
            	email: sEmail,
            	// birthday: $('#inputDataNascimento').val(),
            	cpf: $('#inputCPF').val(),
            	cnpj: $('#inputCNPJ').val(),
            	company_name: sCompanyName,
            	country_id: $('#inputPais').val(),
            	city_id: $('#cidade').val(),
            	state: $('#estado').val(),
            	new_city: sNewCity,
            	new_state: sNewState,
            	zipcode: $('#inputCEP').val(),
            	address: sAddress,
            	number: sNumber,
            	complement: sComplement,
            	neighborhood: sNeighborhood,
            	literal_state: sLiteralState,
            	literal_city: sLiteralCity,
            	phone_home: $('#inputTelefoneResidencial').val()
            },
            dataType: 'json',
            cache: false,
            timeout: 20000,
            success: function(json) {
            	$('#divLoadingContent').hide();
            	if (json.retorno=='ok') {
                    // $('html, body').animate({
                    // 	scrollTop: $(".panel-sidebar").offset().top - 87
                    // }, 2000)
                    if(ProjectPage.userFreeUpdate != true) {
	                    if(ProjectPage.freeReward) {
	                    	ProjectPage.chooseFreeRewards(ProjectPage.project_id);
	                    }
	                    if(ProjectPage.multipleRewards) {
	                    	ProjectPage.chooseRewards(ProjectPage.project_id, ProjectPage.multipleRewardsData);
	                    }
	                    if(ProjectPage.choosenDirectReward != null) {
	                    	// var url = App.webRoot + 'projeto/ajaxContribuicaoRevisao/' +
	                    	// 	  + ProjectPage.project_id;
	                    	var RewardData =  [
						        {
						            id: ProjectPage.choosenDirectReward,
						            quantity: 1
						        }
						    ];
	                    	ProjectPage.chooseRewards(ProjectPage.project_id, RewardData);
	                    }
	                } else {
	                	ProjectPage.goBackConfirmation();
	                }
                } else {
                	var url = App.webRoot + 'projeto/ajaxMensagem/erro-atualiza-endereco';
                	ProjectPage.goToNext(url);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
            	switch(jqXHR.status){
            		case 400:
            		$.each(jqXHR.responseJSON,function(key,value){
            			// if(key == 'birthday')
            			// 	key = 'data_nascimento';
            			var error = $('<label></label>').addClass('error').text(value);
            			$('input[name='+key+']').parent().append(error);
                        // $('#inputDataNascimento').addClass('error').removeClass('valid').focus();
            		});
            		Utils.goToSidebarTop();
            		// alert('Um campo foi preenchido incorretamente');
            		break;
            		case 408:
            		case 504:
            		$('#divWarning').html('<strong>Ops...</strong><br/><br/>Parece que algum problema ocorreu no acesso ao servidor quando tentamos gravar seus dados.<br/><br/>Verifique se seu acesso a internet está ok e tente novamente.<br/><br/>Pedimos desculpas pelo ocorrido.<br/>');
            		$('#divWarning').show();
            		break;
            		default:
            		//alert('Erro!\n\n'+errorThrown);
            		break;
            	}
            	$('#divLoadingContent').hide();
            	$('.js-evbind-updateUserSidebar').prop('value','ATUALIZAR');
            	$('.js-evbind-updateUserSidebar').prop('disabled',false);
            	return false;
            }
        	});
        }
	}, //end of function userUpdate()
}